export default function Event({ color ,fill}) {
    return (
<svg width="18" height="22" viewBox="0 0 18 22" fill={fill} xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="1" width="16" height="20" rx="4" stroke={color} strokeWidth="1.5"/>
<path d="M9 6L13 6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
<path d="M5 6L6 6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
<path d="M5 11H6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
<path d="M9 11L13 11" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
<path d="M5 16H9" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
</svg>

    )
}